// extracted by mini-css-extract-plugin
export var gif = "_d2-0";